// extracted by mini-css-extract-plugin
export default {"addToCartControl":"eZ-z","giftCard":"fZ-z","btnContainer":"gZ-z","cartButton":"hZ-z","disabled":"iZ-z","stockMessage":"jZ-z"};